import { PrepTimeCalculationRuleTypeEnum } from '../enum';
export const prepTimeCalculationContext = { prepTime: 15 };
export const prepTimeCalculationByPriceRange = { from: 0, to: 100, context: { prepTime: 20 } };
export const prepTimeCalculationByPriceRule = {
    type: PrepTimeCalculationRuleTypeEnum.BY_PRICE,
    isEnabled: true,
    ranges: [prepTimeCalculationByPriceRange],
};
export const prepTimeCalculationWeeklySchedule = {
    mon: [
        {
            interval: '12:00/14:00',
            context: { prepTime: 20 },
        },
        {
            interval: '18:00/20:00',
            context: { prepTime: 25 },
        },
    ],
};
export const prepTimeCalculationByScheduleRule = {
    type: PrepTimeCalculationRuleTypeEnum.BY_SCHEDULE,
    isEnabled: true,
    schedule: prepTimeCalculationWeeklySchedule,
};
//# sourceMappingURL=example.js.map